// extracted by mini-css-extract-plugin
export default {"container":"ModalFormWindow_container__YNfrO","header":"ModalFormWindow_header__ZFkR6"};